import CONSTANT from 'modules/constant'
import type {
  CarModelProps,
  DropdownCategoryListProps,
  PaginationProps,
  PopUpBannerProps,
  ResultProps
} from 'modules/types'
import type { PartialCreatePopUpBannerModelProps } from 'modules/partial'
import { API, headers } from './api'

const PopUpBannerApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getPopUpBannerList: builder.mutation<PaginationProps<PopUpBannerProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_POP_UP_BANNER_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: body,
        formData: true
      })
    }),
    getPopUpBannerDetail: builder.query<PopUpBannerProps, number | string>({
      query: (id) => ({
        url: CONSTANT.URL_POP_UP_BANNER_DETAIL.replace('{id}', id.toString()),
        method: 'GET',
        headers: headers()
      })
    }),
    createPopUpBanner: builder.mutation<ResultProps, PartialCreatePopUpBannerModelProps>({
      query: (body) => ({
        url: CONSTANT.URL_POP_UP_BANNER_CREATE,
        method: 'POST',
        headers: headers(),
        body: body
      })
    }),
    getCarModelDropdown: builder.mutation<CarModelProps[], void>({
      query: () => ({
        url: CONSTANT.URL_PUSH_NOTIFICATION_CAR_MODEL_DROPDOWN,
        method: 'GET',
        headers: headers()
      })
    }),
    getMemberTierDropdown: builder.mutation<DropdownCategoryListProps[], void>({
      query: () => ({
        url: CONSTANT.URL_PUSH_NOTIFICATION_MEMBER_TIER_DROPDOWN,
        method: 'GET',
        headers: headers()
      })
    }),
    deletePopUpBanner: builder.mutation<ResultProps, { id: number }>({
      query: (body) => ({
        url: CONSTANT.URL_POP_UP_BANNER_DELETE + `/${body.id}`,
        method: 'DELETE',
        headers: headers()
      })
    }),
    updatePopUpBanner: builder.mutation<ResultProps, PartialCreatePopUpBannerModelProps>({
      query: (body) => ({
        url: CONSTANT.URL_POP_UP_BANNER_UPDATE + `/${body.id}`,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: body,
        formData: true
      })
    })
  })
})

export const {
  useGetPopUpBannerListMutation,
  useGetPopUpBannerDetailQuery,
  useCreatePopUpBannerMutation,
  useGetCarModelDropdownMutation,
  useGetMemberTierDropdownMutation,
  useDeletePopUpBannerMutation,
  useUpdatePopUpBannerMutation
} = PopUpBannerApi
